// Module
var code = "<div class=toggle ng-click=switchToggle()><div class=toggle-container><div class=on-toggle><p>{{ on }}</p></div><div class=toggle-button ng-class=\"{ 'toggled-on': toggle._toggled }\"></div><div class=off-toggle><p>{{ off }}</p></div></div></div>";
// Exports
module.exports = code;